import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './InsightsPage.css';
import './leaderboard_bbc.css';
import { FiBarChart2, FiGrid, FiSettings, FiChevronDown } from 'react-icons/fi';
import { GiGolfTee } from 'react-icons/gi';
import PlayerStats from './PlayerStats';
import TournamentInsights from './TournamentInsights';
import AllTimeInsights from './AllTimeInsights';
import BottomNav from './BottomNav';
import { useApi } from './useApi';
import { useAuth } from './AuthContext';
import PageHeader from './components/PageHeader';
import TournamentSelectorModal from './components/TournamentSelectorModal';

const Analyze = () => {
  const { authenticatedFetch } = useApi();
  const { currentSociety } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  const queryParams = new URLSearchParams(location.search);
  const urlTournamentId = queryParams.get('tournament');

  const [activeTab, setActiveTab] = useState('player');
  const [selectedTournamentId, setSelectedTournamentId] = useState(urlTournamentId || '');
  const [selectedTournamentData, setSelectedTournamentData] = useState(null);
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);
  const [isPageReady, setIsPageReady] = useState(false);

  const fetchTournamentData = useCallback(async (tid) => {
    if (!tid) {
      setIsPageReady(true);
      return;
    }
    try {
      const res = await authenticatedFetch(`/tournaments/${tid}`);
      if (res.ok) {
        const data = await res.json();
        setSelectedTournamentData(data);
      }
    } catch (error) { 
      console.error(error); 
    } finally {
      setIsPageReady(true);
    }
  }, [authenticatedFetch]);

  useEffect(() => {
    if (selectedTournamentId) {
      fetchTournamentData(selectedTournamentId);
    } else {
      setIsPageReady(true);
    }
  }, [selectedTournamentId, fetchTournamentData]);

  const insightsMenuItems = [
    { name: 'Leaderboard', route: '/leaderboard', icon: <FiBarChart2 size={24} /> },
    { name: 'Rounds', route: '/tournaments/scorecard-entry', icon: <FiGrid size={24} /> },
    { name: 'Play Golf', route: '/play', icon: <GiGolfTee size={24} /> },
    { name: 'Manage', route: '/setup', icon: <FiSettings size={24} /> },
  ];

  if (!currentSociety) return <div style={{padding:'40px', textAlign:'center'}}><h3>No Society</h3><button onClick={()=>navigate('/setup')}>Go to Setup</button></div>;

  return (
    <div className={`leaderboard-page-container insights-page ${isPageReady ? 'content-ready' : ''}`}>
      <PageHeader title="Insights" backTo={-1} />

      <div className="analyze-tabs">
        <div className="tab-pill-container">
          <button className={activeTab === 'player' ? 'active' : ''} onClick={() => setActiveTab('player')}>Player</button>
          <button className={activeTab === 'tournament' ? 'active' : ''} onClick={() => setActiveTab('tournament')}>Tournament</button>
          <button className={activeTab === 'allTime' ? 'active' : ''} onClick={() => setActiveTab('allTime')}>All Time</button>
        </div>
      </div>

      <div className="analyze-content">
        {activeTab === 'allTime' && <AllTimeInsights />}
        {activeTab === 'tournament' && (
          <>
            {/* Broadcast Grade Tournament Selector */}
            <div className="tournament-selector-row centered" style={{ padding: '0 16px 20px' }}>
                <div className="tournament-control-container">
                    <span className="selector-section-label">TOURNAMENT</span>
                    <button className="premium-tournament-selector" onClick={() => setIsSelectorOpen(true)}>
                        <div className="selector-content-left">
                            <span className="selector-active-name">
                                {selectedTournamentData ? selectedTournamentData.name : 'Select Tournament'}
                            </span>
                        </div>
                        <FiChevronDown className={`selector-chevron-premium ${isSelectorOpen ? 'rotated' : ''}`} />
                    </button>
                    <div className="selector-accent-bar" />
                </div>
            </div>
            
            <TournamentSelectorModal 
              isOpen={isSelectorOpen}
              onClose={() => setIsSelectorOpen(false)}
              onSelect={(id) => {
                setSelectedTournamentId(id);
                navigate(`?tournament=${id}`);
              }}
              selectedId={selectedTournamentId}
            />
            
            <TournamentInsights selectedTournamentId={selectedTournamentId} />
          </>
        )}
        {activeTab === 'player' && <PlayerStats />}
      </div>
      <BottomNav menuItems={insightsMenuItems} />
    </div>
  );
};

export default Analyze;
